module.exports = __webpack_public_path__ + "static/img/arrow-down-gray.54cf034.png";


//////////////////
// WEBPACK FOOTER
// ./src/RF_assets/icons/arrow-down-gray.png
// module id = NJEu
// module chunks = 88